import { createFileRoute } from "@tanstack/react-router";
import { getSocialEmotionalAddPage } from "#/modules/sociaal-emotioneel/social-emotional.functions";
import { SociaalEmotioneelThemasReeksCrudPage } from "#/modules/sociaal-emotioneel/components/page.crud-sociaal-emotioneel";

export const Route = createFileRoute(
  "/$locale/{-$schoolyear}/_authenticated/$school/social-emotional/add/",
)({
  loader: () => getSocialEmotionalAddPage(),
  component: SchoolSocialEmotionalAddPage,
});

function SchoolSocialEmotionalAddPage() {
  const loaderData = Route.useLoaderData();
  return (
    <SociaalEmotioneelThemasReeksCrudPage
      sociaalEmotioneelThemasReeks={loaderData.sociaalEmotioneelThemasReeks}
      isEditRoute={loaderData.isEditRoute}
      basePath="../social-emotional"
    />
  );
}
